import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utilRules from '@/libs/rules';
import bankList from '@/const/bank';
import paymentBook from '../paymentBook/index.vue';
var formData = {
  payerAccountName: '',
  payerAccount: '',
  payerBankName: '',
  depositAmount: undefined,
  depositImage: ''
};

var rulelist = _toConsumableArray(Object.keys(formData).map(function (v) {
  return v;
}));

export default {
  components: {
    paymentBook: paymentBook
  },
  data: function data() {
    return {
      options: bankList,
      checked: false,
      formData: formData,
      rules: utilRules(rulelist),
      depositInfo: {},
      dialogFormVisible: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.dataBind();

              _this.getQiNiu();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.$api.depositInfo(item);

              case 2:
                data = _context2.sent;
                _this2.depositInfo = data;
                console.log(data);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.formData, key, this.VUE_APP_IMG_BASE + response.key);
      this.$refs['loginForm'].clearValidate(key);
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    submit: function submit() {
      var _this3 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (valid) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  if (_this3.checked) {
                    _context3.next = 4;
                    break;
                  }

                  return _context3.abrupt("return", YL.message('请先阅读并同意《要炼诚信保证金》协议', 'error'));

                case 4:
                  _context3.next = 6;
                  return _this3.$api.deposit(_this3.formData);

                case 6:
                  YL.message('缴纳成功,等待管理员审核');
                  YL.isStoreAuto(4);

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};